import { Component, Input } from '@angular/core';
import { OrderStatus } from '../../interface/order.interface';

@Component({
  selector: 'app-history-status',
  templateUrl: './history-status.component.html',
  styleUrl: './history-status.component.scss'
})
export class HistoryStatusComponent {
  @Input() data: any[] = [];
  @Input() orderStatus: OrderStatus;
  
  doneOrderStatus = OrderStatus.Done;
  cancelledOrderStatus = OrderStatus.Cancelled;
}
